export default __webpack_public_path__ + "static/media/announce.9ba73556.svg";